import { Service } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpServiceBase } from './http-service-base';

/** HTTP access to the admin API (`adminApiUrl`). The default API for the app. */
@Service()
export class HttpService extends HttpServiceBase {
  protected readonly baseUrl = environment?.adminApiUrl ?? '';
}
